import api from "@/plugins/api";
// Sibling of `/organisations/settings/rfm` — same settings page family, OPDON upstream.
const ENDPOINT = "/organisations/settings/tax-receipts";
const OPTIONS = { unwrapEnvelope: true };
function mapResponse(data) {
    return {
        ...data,
        campaignNotificationUserIds: data.campaignNotificationUserIds ?? [],
        campaignNotificationRoles: data.campaignNotificationRoles ?? [],
        documentTemplateIndividualId: data.documentTemplateIndividualId ?? null,
        documentTemplateOrganizationId: data.documentTemplateOrganizationId ?? null,
        updatedAt: data.updatedAt ?? null,
    };
}
export async function getTaxReceiptSettings() {
    const response = await api.get(ENDPOINT, OPTIONS);
    return mapResponse(response.data);
}
export async function updateTaxReceiptSettings(payload) {
    const response = await api.put(ENDPOINT, payload, OPTIONS);
    return mapResponse(response.data);
}
